import { api } from 'shared/api'

import { ConvertKitSchemas } from './schemas'

export const convertKitApi = {
  setAccountLinkField: api.account.createPost({
    url: '/integration/convertkit/setAccountLinkField',
    schemas: ConvertKitSchemas.setAccountLinkField,
  }),
  clearAccountLinkField: api.account.createPost({
    url: '/integration/convertkit/clearAccountLinkField',
    schemas: ConvertKitSchemas.clearAccountLinkField,
  }),
  getForms: api.account.createGet({
    url: '/integration/convertkit/getForms',
    schemas: ConvertKitSchemas.getForms,
  }),
  getSequences: api.account.createGet({
    url: '/integration/convertkit/getSequences',
    schemas: ConvertKitSchemas.getSequences,
  }),
  getTags: api.account.createGet({
    url: '/integration/convertkit/getTags',
    schemas: ConvertKitSchemas.getTags,
  }),
  getFields: api.account.createGet({
    url: '/integration/convertkit/getFields',
    schemas: ConvertKitSchemas.getFields,
  }),
}
